import { t } from "ttag";

import { useSelector } from "metabase/redux";
import { getNoObjectIllustration } from "metabase/selectors/whitelabel";
import type { ImageProps } from "metabase/ui";
import { Image } from "metabase/ui";

export function NoObjectError(props: ImageProps) {
  const noObjectIllustration = useSelector(getNoObjectIllustration);

  return noObjectIllustration ? (
    <Image
      alt={t`Nothing found`}
      w={120}
      h={120}
      src={noObjectIllustration}
      {...props}
    />
  ) : null;
}
